import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Lock, Mail, Info, Heart } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';
import { useI18n } from '../../contexts/I18nContext';

export function Footer() {
  const { t } = useTranslation();
  const { getPathForLang } = useI18n();

  return (
    <>
      {/* Footer Desktop uniquement */}
      <footer className="bg-white border-t mt-auto hidden md:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="text-center">
            <nav className="space-x-6 mb-4" aria-label="Footer Navigation">
              <Link to={getPathForLang('/about')} className="text-gray-500 hover:text-gray-900 transition-colors inline-flex items-center">
                <Info className="w-4 h-4 mr-2" />
                {t('footer.about')}
              </Link>
              <Link to={getPathForLang('/mentions-legales')} className="text-gray-500 hover:text-gray-900 transition-colors inline-flex items-center">
                <FileText className="w-4 h-4 mr-2" />
                {t('footer.legal')}
              </Link>
              <Link to={getPathForLang('/confidentialite')} className="text-gray-500 hover:text-gray-900 transition-colors inline-flex items-center">
                <Lock className="w-4 h-4 mr-2" />
                {t('footer.privacy')}
              </Link>
              <a href="https://www.paypal.com/donate/?hosted_button_id=D95N2F3624FKQ" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-900 transition-colors inline-flex items-center">
                <Heart className="w-4 h-4 mr-2" />
                {t('footer.support')}
              </a>
              <Link to={getPathForLang('/contact')} className="text-gray-500 hover:text-gray-900 transition-colors inline-flex items-center">
                <Mail className="w-4 h-4 mr-2" />
                {t('footer.contact')}
              </Link>
            </nav>
            <p className="text-xs text-gray-400">
              {t('footer.disclaimer')}
            </p>
          </div>
        </div>
      </footer>

      {/* Navigation Mobile */}

    </>
  );
}